import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";

// This hook will be removed once the migration to new Comms microservice
// is completed and enabled on production by default.
export const useCommsNewEndpoints = () => {
  const { data: config } = useInstanceConfigQuery();
  const shouldUseCommsNewEndpointsBasedOnConfig =
    config?.custom_ui_labels?.use_comms_new_endpoints;

  return !!shouldUseCommsNewEndpointsBasedOnConfig;
};
